import * as actionType from './type';

const INITIAL_STATE = {
    entityDetails: {},
    allEntityData : []
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_LEAD_TEXTFIELD_DETAILS: {
            return {
                ...state,
            }
        }

        case actionType.RECEIVED_LEAD_TEXTFIELD_DETAILS: {
            return {
                ...state,
                entityDetails : action.payload || {}
            }
        }
        case actionType.REQUEST_ALL_TEXTFIELD_DETAILS: {
            return {
                ...state,
            }
        }

        case actionType.RECEIVED_ALL_TEXTFIELD_DETAILS: {
            return {
                ...state,
                allEntityData : Array.isArray(action.payload) ? action.payload : [],
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                error: "Please try again"
            }
        }

        default: 
            return state;
    }
}